export interface PushHistoryStackEntryAction<
  A extends string = string,
  N extends string = string,
  S = {}
> {
  name: N;
  state?: S;
  type: A;
}

export const createPushHistoryStackEntryActionCreator = <
  A extends string,
  N extends string,
  S
>(
  actionTypePrefix: string,
): ((name: N, state?: S) => PushHistoryStackEntryAction<A>) => (
  name: N,
  state?: S,
): PushHistoryStackEntryAction<A, N, S> => ({
  name,
  state,
  type: (actionTypePrefix + 'PUSH') as A,
});
